// Module
var code = "<style>:host{display:inline-block;height:max-content;min-height:1em;min-width:5em}#text{max-width:100%;overflow:hidden;display:inline-block;align-items:center;text-overflow:ellipsis;white-space:nowrap;word-break:break-all;pointer-events:none}</style> <div id=\"text\"></div>";
// Exports
export default code;